import React from 'react';
import useNow from '../../../hooks/useNow';
import { templateCodeOf, upcomingVisit } from '../../../logic/task';
import { STAFF_VISIT_CODES } from '../../../logic/visits';

// The patient's next Elation Virtual Visit, off WF69's appointment stamp. Derived from the tasks
// the shell already holds. Rendering nothing means "nothing recorded", never "no visit booked" —
// and the hover text says the sync is not a live connection, because it runs every 2h.
//
// `compact` once the topbar condenses: the four action buttons appear there and the patient's name
// is the row's only shrinkable element, so the full sentence would be paid for out of their name.
// Same trade the back link already makes at that breakpoint. The hover text never shortens.
export default function NextVisitChip({ tasks, compact = false }) {
  const nowMs = useNow();
  // The staff visit tasks only: each patient card stamps the same appointment as its staff task.
  const visits = (tasks || []).filter((t) => STAFF_VISIT_CODES.includes(templateCodeOf(t)));
  const visit = upcomingVisit(visits, new Date(nowMs));
  if (!visit) return null;

  // Attention for today and for a visit nobody closed out; informational otherwise. Never
  // --wi-status-bad — red stays for genuinely-late work.
  const attention = visit.bucket === 'today' || visit.bucket === 'passed';
  return (
    <span
      className={`next-visit-chip wi-tip${attention ? ' is-attention' : ''}`}
      data-tip={visit.hint}
      role="note"
      aria-label={visit.hint}
      tabIndex={0}
    >
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
      {compact ? visit.compactLabel : visit.label}
    </span>
  );
}
